import React from 'react';
import { Row, Col, Card } from 'reactstrap';
import { ComponentAsyncSelect } from '../Forms';
import { ParameterForm } from './ParameterForm.types';
import { MethodQuery, OtherCriterionQuery, MatrixQuery } from '../../graphql/Components';
import { ViewMode } from '../Common/ViewMode';
import { KomponenteStatus } from '../../generated/types';



/**
 * this component shows optional parameter components 
 * for released components it is not allowed to remove optional components but it is allowed to add new one  
 * @author Jungwirth
 */
export const ParameterOptionalForm: React.FC<ParameterForm> = ({ viewConfig }: Readonly<ParameterForm>): JSX.Element => {
  const width: number = viewConfig.viewName !== ViewMode.Search ? 12 : 6;

  const kompStatusList: KomponenteStatus[] = viewConfig.viewName === ViewMode.New || viewConfig.viewName === ViewMode.Edit 
    ? [KomponenteStatus.Ks1, KomponenteStatus.Ks2A] 
    : [];

  return (
    <Card body className="mb-2">
      <Row>
        <Col md={width}>
          <ComponentAsyncSelect
            name="method"
            query={MethodQuery.getPagedComponents()}
            status={kompStatusList}
            path="methoden"
            multi={viewConfig.viewName !== ViewMode.Search}
            getLabel={MethodQuery.getDropdownLabel}
            fieldConfig={viewConfig.fields.method.field}
          />
        </Col>
        <Col md={width}>
          <ComponentAsyncSelect
            name="other_criterion"
            query={OtherCriterionQuery.getPagedComponents()}
            status={kompStatusList}
            path="sonstigeKriterien"
            multi={viewConfig.viewName !== ViewMode.Search}
            fieldConfig={viewConfig.fields.other_criterion.field}
          />
        </Col>
      </Row>
      <Row>
        <Col md={width}>
          <ComponentAsyncSelect
            name="matrix"
            query={MatrixQuery.getPagedComponents()}
            status={kompStatusList}
            path="matrizen"
            multi={viewConfig.viewName !== ViewMode.Search}
            fieldConfig={viewConfig.fields.matrix.field}
          />
        </Col>
      </Row>
    </Card>
  );
};
